module.exports = __webpack_public_path__ + "207b740a7697e662e9c8eb62190d9bbb.svg";